import React, { memo, useCallback, useEffect, useState } from 'react'

import { Notice, Display, Icon } from '@cgtrader/triangle-ui/dist/src/ssr-index'

import useBreakpoint from 'Utils/useBreakpoint'

const DISMISSED_KEY = 'bestOnDesktopDismissed'

const isDismissed = () => {
  try {
    return window.localStorage.getItem(DISMISSED_KEY) === '1'
  } catch (_) {
    return false
  }
}

const dismiss = () => {
  try {
    window.localStorage.setItem(DISMISSED_KEY, '1')
  } catch (_) {
    // Storage may be unavailable (private mode, quota). Treat as no-op.
  }
}

function BestOnDesktop() {
  const breakpoint = useBreakpoint()
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    setIsVisible(!isDismissed())
  }, [])

  const handleClose = useCallback(() => {
    dismiss()
    setIsVisible(false)
  }, [])

  const isMobile = breakpoint === 'xs'

  if (!isMobile || !isVisible) return null

  return (
    <div className="best-on-desktop" role="status" aria-live="polite">
      <Notice
        useSSRIcon
        ssrIcon={<Icon svgComponent={Display} color="darker" className="best-on-desktop__icon" />}
        onClose={handleClose}>
        <div className="best-on-desktop__body">
          <p className="cgt-heading-50 best-on-desktop__title">Best on Desktop</p>
          <p className="cgt-body-base best-on-desktop__text">
            CGTrader AI is designed for larger screens. Some editing tools, settings, and 3D previews
            may not display correctly on mobile. For the best experience, please switch to a desktop.
          </p>
        </div>
      </Notice>
    </div>
  )
}

export default memo(BestOnDesktop)
